import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ListConductor from '@/views/pages/conductor/List.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ListConductor)
  ]))
}
}

})